import request from "./request"

export const getQrLoginPreview = params => request({ url: "/qr-login/ticket_preview_get", method: "get", params })
export const approveQrLogin = data => request({ url: "/qr-login/ticket_approve", method: "post", data })
export const denyQrLogin = data => request({ url: "/qr-login/ticket_deny", method: "post", data })
